import "./App.css";
import AppRouter from "./AppRouter";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";


function App() {
  return (
    <div className="App">
      <ToastContainer />
      <AppRouter />
    </div>
  );
}

export default App;
